import React, { useState, useRef } from 'react';
import styles from '../styles/Category.module.css';

const initialForm = { name: '', icon: '', active: true };

const CategoryForm = ({ onSubmit, onCancel, editingCategory }) => {
  const [form, setForm] = useState(editingCategory || initialForm);
  const [preview, setPreview] = useState(editingCategory?.icon || '');
  const fileInputRef = useRef();

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setForm(f => ({ ...f, icon: reader.result }));
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.name) return;
    onSubmit(form);
    setForm(initialForm);
    setPreview('');
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.formGroup}>
        <label>Category Name</label>
        <input
          name="name"
          type="text"
          value={form.name}
          onChange={handleChange}
          className={styles.input}
          required
        />
      </div>
      <div className={styles.formGroup}> 
        <label htmlFor="Status">Status</label>
        <select
          name="status"
          value={form.status}
          onChange={handleChange}
          className={styles.input}
        >
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </div>
      <div className={styles.formGroup}>
        <label>Category Icon/Image</label>
        <input
          name="icon"
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          className={styles.input}
        />
        {preview && <img src={preview} alt="Preview" className={styles.preview} />}
      </div>
      <div className={styles.formActions}>
        <button type="submit" className={styles.addBtn}>{editingCategory ? 'Update' : 'Add'}</button>
        <button type="button" className={styles.cancelBtn} onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
};

export default CategoryForm;
